import React, { useCallback, useState } from 'react';
import TeamSelector from '../../components/TeamSelector/TeamSelector';
import PlayerCombiner from '../../components/PlayerCombiner/PlayerCombiner';
import clubs from '../../data/clubs.json';
import Title from '../../components/Title/Title';
import { FORMATIONS, randomFormationName } from '../../helpers/formations';
import './SquadPage.css';

const SquadPage = () => {
    const [selectedTeam, setSelectedTeam] = useState('');
    const [randomTeam, setRandomTeam] = useState('');
    const [formation, setFormation] = useState('');
    const [resetKey, setResetKey] = useState(0);

    // La formación se sortea UNA vez, al elegir el club. Antes vivía en un
    // FormationGenerator que la sorteaba dentro de un useEffect y la publicaba hacia
    // arriba: cada re-render del padre podía volver a dispararlo y cambiar la formación
    // a mitad de partida.
    const handleTeamSelect = (team) => {
        setSelectedTeam(team);
        const otherTeams = Object.keys(clubs).filter((t) => t !== team);
        setRandomTeam(otherTeams[Math.floor(Math.random() * otherTeams.length)]);
        setFormation(randomFormationName());
    };

    const handleResetGame = useCallback(() => {
        setSelectedTeam('');
        setRandomTeam('');
        setFormation('');
        setResetKey((prev) => prev + 1); // fuerza el remount del selector
    }, []);

    return (
        <div className="b11-page">
            <Title />
            {!selectedTeam || !formation ? (
                <TeamSelector key={resetKey} onSelect={handleTeamSelect} />
            ) : (
                <PlayerCombiner
                    key={`${selectedTeam}-${resetKey}`}
                    selectedTeam={selectedTeam}
                    randomTeam={randomTeam}
                    positions={FORMATIONS[formation]}
                    formationName={formation}
                    onResetGame={handleResetGame}
                />
            )}
        </div>
    );
};

export default SquadPage;
